import React from "react";
import { Link } from "@remix-run/react";
import { cn } from "~/lib/utils";
import { workspaceSlug } from "~/lib/helpers/slugHelper";
import ReadMore from "./ReadMore";
import { OhButton } from "~/components/ui/custom-radix-components/button";
// import ReadMore from "~/lib/utils/Text/ReadMore";


interface ProviderCardProps {
  // provider: PartnerData;
  sfid: string;
  name: string;
  image: string;
  backgroundImage: string;
  description: string;
  totalProperties: number;
  preferedCrown: boolean,
  className?: string,
  searchString?: string,
  workspaceProvider?: {
    name: string;
    id: string | number;
    sfid: string;
    country?: string;
  }

}


const ProviderCard = React.memo(function ProviderCard({
  name,
  image,
  backgroundImage,
  description,
  totalProperties,
  preferedCrown,
  workspaceProvider,
  className,
  showProviderHeading
}: ProviderCardProps) {

  const targetUrl = workspaceProvider && workspaceProvider.name && workspaceProvider.sfid ? workspaceSlug(workspaceProvider) : "/workspaces";

  return (
    <div
      className={cn(
        "relative rounded-lg border border-gray-200 flex flex-col h-[326px] shadow-custom group hover:shadow-lg transition",
        className,
      )}
    >
      {/* Preferred Partner Crown Badge commented for now */}
      {/* {preferedCrown && (
        <div className='absolute left-3 top-3 z-10'>
          <div className='bg-white rounded-full w-7 h-7 flex items-center justify-center border border-gray-200 shadow-sm'>
            <img
              src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/icons/crown.png`}
              alt='Preferred Partner'
              className='w-4 h-4'
            />
          </div>
        </div>
      )} */}

      {/* Logo Section */}
      <Link
        to={targetUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="relative block z-[2]"
      >
        <div
          className="flex items-center justify-center rounded-t-lg rounded-b-none h-[143px] mb-3 bg-cover bg-center"
          style={{
            backgroundColor: "#E5E7EB",
            backgroundImage: backgroundImage
              ? `url('https://ik.imagekit.io/officehub/tr:h-286,f-avif/${backgroundImage}')`
              : "none",
          }}
        >
          {(image || name) && (
            <div className="absolute left-1/2 top-4 -translate-x-1/2 translate-y-6 bg-white rounded-full shadow-lg flex items-center justify-center px-4 py-[10px] min-w-[140px] min-h-[56px] sm:min-w-[180px] sm:min-h-[64px] md:min-w-[160px] md:min-h-[60px]">
              {image ? (
                <img
                  src={`https://ik.imagekit.io/officehub/tr:h-200,f-avif/${image}`}
                  alt={`${name} logo`}
                  title={name}
                  width={72}
                  height={40}
                  className='max-h-10 max-w-[72px] object-contain'
                  loading="lazy"
                />
              ) : (
                <div className='text-gray-400 text-sm font-medium'>{name}</div>
              )}
            </div>
          )}
        </div>
      </Link>

      {/* Description */}
      {!showProviderHeading ? (
        <Link
          to={targetUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="after:absolute after:inset-0 after:z-[1]"
        >
          <h3 className="text-gray-800 text-sm font-semibold px-4">{name}</h3>
        </Link>
      ) : (
        <Link
          to={targetUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-800 text-sm font-semibold px-4 after:absolute after:inset-0 after:z-[1]"
        >
          {name}
        </Link>
      )}

      {showProviderHeading && (
        <h3 className="hidden">{totalProperties}+ Office Spaces for Rent in {name}</h3>
      )}
      <ReadMore
        className=' font-normal text-xs leading-5 px-4 pb-3 tracking-normal text-gray-700 flex-1 overflow-hidden'
        maxLines={4}
        characters={110}
      >{description}</ReadMore>


      {/* Locations button */}

      <div className='px-4 pb-4 relative z-[2]'>
        <Link to={targetUrl} target="_blank">
          <OhButton asChild variant="tertiary" className='mt-auto text-sm block w-full rounded-lg py-2 text-center font-semibold transition'>
            <span>{totalProperties > 0 ? totalProperties : "Find"} Location{totalProperties === 1 ? "" : "s"}</span>
          </OhButton>
        </Link>
      </div>
    </div>
  );
});

export default ProviderCard;
